module.exports = __webpack_public_path__ + "static/v-class-icon-1e67c4d2ec3b8dc850bfec034cac1b5a.jpg";